import { Tooltip } from "antd"
import React from "react"
import { getTooltipPopupContainer } from "../../../../../shared/utils/helper.utils"

interface DateListElementProps {
    title: string
    label: string
    date: string
    style?: React.CSSProperties
}

export const DateListElement = ({ title, label, date, style }: DateListElementProps) => (
    <li>
        <span className="title">
            <Tooltip getPopupContainer={getTooltipPopupContainer} placement="bottom" title={title}>
                {label}
            </Tooltip>
        </span>
        <span className="text" style={style}>
            {date}
        </span>
    </li>
)
